import { MOBILE_CAPABILITIES } from '~/constants'

import type { Platform } from '~/types/platform'

/**
 * This composable checks if the user is using a webview.
 */
export default function usePlatform() {
  const platformCookie = usePlatformCookie()

  const { isMobileOrTablet } = useDevice()
  const platform: ComputedRef<Platform> = computed(() => {
    return platformCookie.value ? platformCookie.value : isMobileOrTablet ? 'mobile_web' : 'web'
  })

  const isWebViewAndroid = computed(() => platform.value === 'android')
  const isWebViewIOS = computed(() => platform.value === 'ios-v1')
  const isWebView = computed(() => isWebViewAndroid.value || isWebViewIOS.value)

  const capabilitiesCookie = useCapabilitiesCookie()
  const mobileCapabilities = computed(() => {
    return (Object.keys(MOBILE_CAPABILITIES) as MOBILE_CAPABILITIES[]).reduce((acc, capability) => {
      acc[capability] = Boolean(capabilitiesCookie.value?.includes(MOBILE_CAPABILITIES[capability]))
      return acc
    }, {} as Record<MOBILE_CAPABILITIES, boolean>)
  })

  const isAutomatedTest = useAutomatedTestCookie()

  return {
    isAutomatedTest,
    isWebViewAndroid,
    isWebViewIOS,
    isWebView,
    mobileCapabilities,
    platform,
  }
}
